module.exports = __webpack_public_path__ + "static/unaceite-42677913794024cc2379545450b52251.png";